import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import {CommonButton} from './CommonButton';

// ネガティブボタンスタイル
const styles = (theme) => createStyles({
  root: {
    color: '#000000',
    backgroundColor: '#FFFFFF',
    borderColor: '#C0C0C0',
  },
});

/** ネガティブボタン */
export const NegativeButton = withStyles(styles)(CommonButton);
export default NegativeButton;
